module.exports = [
  {
    name: 'Eisenstadt und Umgebung',
    slug: 'Eisenstadt_und_Umgebung',
    zoomToIso: 103,
    filter: iso => iso >= 10100 && iso < 10400,
  },
  {
    name: 'Neusiedl',
    zoomToIso: 107,
    filter: iso => iso >= 10700 && iso < 10800,
  },
  {
    name: 'Mattersburg',
    zoomToIso: 106,
    filter: iso => iso >= 10600 && iso < 10700,
  },
  {
    name: 'Oberpullendorf',
    zoomToIso: 108,
    filter: iso => iso >= 10800 && iso < 10900,
  },
  {
    name: 'Oberwart',
    zoomToIso: 109,
    filter: iso => iso >= 10900 && iso < 11000,
  },
  {
    name: 'Güssing',
    slug: 'Guessing',
    zoomToIso: 104,
    filter: iso => iso >= 10400 && iso < 10500,
  },
  {
    name: 'Jennersdorf',
    zoomToIso: 105,
    filter: iso => iso >= 10500 && iso < 10600,
  },
]



// WEBPACK FOOTER //
// ./src/data/bezirke.js